export default "__VITE_ASSET__BIVO2hf8__"